import axios from 'axios'
import global from './modules/global'
import auth from './modules/auth'
import checkin from './modules/checkin'
import shops from './modules/shops'
import cart from './modules/cart'
import order from './modules/order'
import notices from './modules/notices'

export default {
    auth,
    checkin,
    global,
    shops,
    cart,
    order,
    notices
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/index.js
// module id = null
// module chunks = 